import { jsx as _jsx, jsxs as _jsxs } from "theme-ui/jsx-runtime";
import React from "react";
import { Box, Flex, Grid } from "theme-ui";
import { processColorMode, HeadingRegularVariants } from "../../";
export const TableContent = ({ title, values, mode = "light" }) => {
    return (_jsxs(Box, { sx: Object.assign(Object.assign({}, processColorMode(mode)), { borderLeftWidth: ["1px", null, null, "1px"], borderRightWidth: ["1px", null, null, "1px"], borderBottomWidth: ["1px", null, null, "1px"], borderTopWidth: ["1px", null, null, "1px"], borderLeftStyle: "solid", borderRightStyle: "solid", borderBottomStyle: "solid", borderTopStyle: "solid", width: "100%" }), children: [_jsx(Flex, { sx: Object.assign(Object.assign({ display: "flex", width: " 100%", textAlign: "left" }, processColorMode(mode)), { borderBottomStyle: "solid", borderTopWidth: "0px", borderLeftWidth: "0px", borderRightWidth: "0px", borderBottomWidth: "1px", px: 32, py: 32 }), children: _jsx("h6", { sx: { variant: `text.${HeadingRegularVariants.sixth}` }, className: "color-mode-title", children: title }) }), _jsx(Grid, { as: "dl", sx: {
                    width: "100%",
                    px: 32,
                    py: 32,
                    columnGap: 24,
                    rowGap: [8, null, null, 32],
                    gridTemplateColumns: [
                        "auto",
                        "auto",
                        "auto",
                        "1fr minmax(50%, 70%)",
                        "1fr minmax(50%, 80%)"
                    ],
                    variant: "text.label2"
                }, children: values.map((kv, index) => {
                    return (_jsxs(React.Fragment, { children: [_jsx(Box, { as: "dt", children: kv.label }), _jsx(Box, { as: "dd", className: "color-mode-title", sx: { mb: [24, null, null, 0] }, children: kv.value })] }, `spec-${index}`));
                }) })] }));
};
//# sourceMappingURL=TableContent.js.map